import React, { useEffect, useRef } from 'react';
import '../../../../vdisolutions/Stylesv/EndUserComputingSection.css';
import backupImage from '../../../../assets/services/backup/cloud-backup-service.svg'; // Update with correct path
// import Cards from "./Cards";
const BackUpService = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const elements = [textRef.current, imageRef.current];
    const options = { threshold: 0.1 };

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    elements.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="end-user-section white-bg">
      <div className="end-user-container">
        <div className="end-user-text" ref={textRef}>
          <h1>Modern Backup Service with Resilience</h1>
          <p>
            Synectiks offers a modern backup service that protects every workload, integrates with security tools and compliance tools. This solution is available for servers, endpoints, VMs, business-critical applications, databases and more. The features include anti-malware and AI-assisted scanning of backup images, Safe Recovery to prevent restoration of infected machines, Geo-redundant and immutable storage, replication, encryption, Archival retention and forensic backups for regulated industries. The solution has centralized plans, monitoring, alerts and reporting, pay-as-you-go licensing per workload or per GB, use your own public cloud storage, Private Cloud storage or hybrid model. Deep Compression technologies used to optimize backup storage capacity.
          </p>
        </div>
        <div className="end-user-image" ref={imageRef}>
          <img src={backupImage} alt="Cloud Backup Service" />
        </div>
      </div>
      {/* <Cards />  */}
    </section>
  );
};

export default BackUpService;
